import _ from "lodash";
import api from "@/service/webSetting.js";

const state = {
  block: [],
  defaultBlock: [{
    delete: false,
    model: "",
    title: {
      name: "",
      bName: "",
      linkName: "",
      linkUrl: "",
    },
    slide: {
      model: "",
      timer: {
        show: false,
      },
      hotSearch: {
        show: false,
      },
    },
    hotkey: {
      model: ""
    },
    multiProduct: {
      model: "",
      subModel: "",
      submitName: "",
    },
    singleProduct: {
      model: "",
      subModel: "",
      submitName: "",
      backImage: "",
    },
    list:{
      model: "",
      subModel: "",
      submitName: "",
    },
    dataList: [],
  }],
  blockManage: {
    slide: [],
    hotkey: [],
    multiProduct: [],
    singleProduct: [],
    list: []
  }
};
const getters = {}
const actions = {
  saveWebSetting({
    state,
    commit
  }, data) {
    let result = api.saveWebSetting(data);
    result.then((data) => {
      let temp = state.defaultBlock;
      if (data.data.state) {
        temp = (data.data.result.length > 0) ? data.data.result : state.defaultBlock;
      }
      commit("setBlockList", temp);
    });
    return result;
  },

  getWebSetting({
    state,
    commit
  }) {
    let result = api.getWebSetting();
    result.then((data) => {
      let temp = state.defaultBlock;
      if (data.data.state) {
        temp = (data.data.result.length > 0) ? data.data.result : state.defaultBlock;
      }
      commit("setBlockList", temp);
      commit("setBlockManage", temp);
    });
    return result;
  },

  saveModelList({
    state,
    commit
  }, data) {
    let result = api.saveModelList(data);
    result.then((data) => {
      console.log("save model list");
    });
    return result;
  },

  deleteModelList({
    state,
    commit
  }, data) {
    let result = api.deleteModelList(data);
    result.then((data) => {
      console.log("delete model list");
    });
    return result;
  },
};
const mutations = {
  setBlockList(state, data) {
    state.block = data;
  },

  setBlockManage(state, data) {
    let temp = _.filter(data, (item, key) => {
      return (item.model != "");
    });

    temp = _.groupBy(temp, "model");

    let manageTemp = _.mapValues(state.blockManage, (item, key) => {
      return temp[key] ? temp[key] : item;
    });

    state.blockManage = manageTemp;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
